<template>
  <div style="display: inline-block; margin: 0 0 0 10px">
    <vue-easy-print ref="easyPrint">
      <template slot-scope="func">
        <template v-if="tenantList.yisen.includes(tennatId)">
          <h1 style="font-size: 30px; text-align: center; padding: 10px 0">
            销售出货单
          </h1>
          <div style="display: flex">
            <div style="line-height: 30px; width: 400px">
              <div>开单日期：{{ info.orderDate }}</div>
              <div>购货单位：{{ info.buyerOrg }}</div>
              <div>地址：{{ info.buyerAddr }}</div>
              <div>电话：{{ info.buyerTel }}</div>
            </div>
            <div style="line-height: 30px; margin-left: 30px; width: 400px">
              <div>单号：{{ info.orderNo }}</div>
              <div>购销单位：{{ info.sellerOrg }}</div>
              <div>地址：{{ info.sellerAddr }}</div>
              <div>电话：{{ info.sellerTel }}</div>
            </div>
          </div>
          <el-table
            :data="info.goods"
            border
            class="print-table"
            :span-method="arraySpanMethod"
          >
            <el-table-column label="产品名称" prop="name"> </el-table-column>
            <el-table-column
              label="规格"
              prop="specifications"
              width="50"
              size="mini"
            ></el-table-column>
            <el-table-column
              label="单位"
              prop="unit"
              width="50"
            ></el-table-column>
            <el-table-column
              label="数量"
              prop="quantity"
              width="50"
            ></el-table-column>
            <el-table-column
              label="单价"
              prop="price"
              width="50"
            ></el-table-column>
            <el-table-column label="金额" prop="value"></el-table-column>
            <el-table-column label="产品批号" prop="batchNo"></el-table-column>
            <el-table-column
              label="生产日期"
              prop="manufactureDate"
              width="94"
            ></el-table-column>
            <el-table-column
              label="有效期"
              prop="effectiveDate"
              width="94"
            ></el-table-column>
            <el-table-column
              label="产品注册证号"
              prop="licenseNo"
              width="110"
            ></el-table-column>
            <el-table-column label="零售价" prop="sellPrice"></el-table-column>
            <el-table-column
              label="生产厂家"
              prop="manufacturer"
              width="110"
            ></el-table-column>
          </el-table>
          <div
            style="
              display: flex;
              justify-content: space-between;
              margin-top: 30px;
            "
          >
            <div>客户姓名：</div>
            <div>仓管员：</div>
            <div>业务员：</div>
            <div style="margin-right: 80px">开单人：</div>
          </div>
        </template>
        <template v-else>
          <p
            style="
              display: flex;
              justify-content: space-between;
              align-items: flex-end;
              width: 74%;
              height: 80px;
              line-height: 80px;
              border-bottom: 1px solid #e9e9e9;
            "
          >
            <span style="color: transparent"
              >编号：{{ printData.customOrderNo || printData.stockOutNo }}</span
            >
            <span style="font-size: 24px">出库记录</span>
            <span style=""
              >编号：{{ printData.customOrderNo || printData.stockOutNo }}</span
            >
          </p>
          <p style="height: 68px; line-height: 68px; width: 100%">
            <span style="width: 40%; display: inline-block"
              >收货名称：{{ printData.inOrgName }}</span
            >
            <span style="width: 50%"
              >出库仓库：{{ printData.outWarehouseName }}</span
            >
          </p>
          <el-table
            :data="printDetails || printData.bizOrderDetails"
            style="width: 100%"
            border
            class="print-table"
          >
            <el-table-column
              prop="spuCode"
              label="商品编码"
              width="160"
            ></el-table-column>
            <el-table-column
              prop="skuName"
              label="商品名称"
              width="220"
            ></el-table-column>
            <el-table-column
              prop="codeBatchNo"
              label="生产批次"
              width="190"
            ></el-table-column>
            <el-table-column
              prop="unitName"
              label="单位"
              width="100"
            ></el-table-column>
            <el-table-column
              :prop="printDetails ? 'printQuality' : 'quality'"
              label="数量"
              width="102"
            ></el-table-column>
            <el-table-column
              prop="updateDate"
              label="出库时间"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="modifier"
              label="操作人"
              width="120"
            ></el-table-column>
          </el-table>
          <p style="height: 68px; line-height: 68px; width: 100%">
            <span style="width: 40%; display: inline-block"
              >打印时间：{{ printTime }}</span
            >
            <span style="width: 50%">打印人：{{ printer }}</span>
          </p>
        </template>
      </template>
    </vue-easy-print>
    <el-button @click="printOrder(printData)" type="warning" plain>打印</el-button>
  </div>
</template>
<script>
import vueEasyPrint from 'vue-easy-print';
import dateUtil from '../../../../common/utils/dateUtil';
import Nzh from 'nzh/cn';
export default {
    components: {
        vueEasyPrint
    },
    props: ['printData', 'visible', 'headerData', 'tennatId', 'tenantList'],
    created() {
        this.printTime = dateUtil.dateFormat();
        let userInfo = baseStore.getUserInfo();
        this.printer = userInfo.realName;
        // 如果是奕森的就调用这个接口并且显示
        if (this.tenantList.yisen.includes(this.tennatId)) {
            this.getPrint();
        }
    },
    mounted() {},
    data() {
        return {
            printTime: '', // 打印时间
            printer: '', // 打印人,
            info: {
                goods: []
            },
            Nzh,
            printDetails: []
        };
    },
    methods: {
        closeDialog() {
            this.$parent.printVisible = false;
        },
        // 点击打印订单
        printOrder(printData) {
            this.$http.get(WebApi.order.stockOutIn + '/' + printData.id).then(response => {
                console.log(response, 'printOrderDetails');
                this.printDetails = response.data.data.printOrderDetails;
                console.log(this.printDetails, 'this.printDetails');
                if (response.status === 200) {
                    this.$nextTick(() => {
                        this.$refs['easyPrint'].print();
                    });
                }
            });
        },
        arraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === this.info.goods.length - 2) {
                if (columnIndex === 0) {
                    return [1, 12];
                }
            } else if (rowIndex === this.info.goods.length - 1) {
                if (columnIndex === 0) {
                    return [1, 12];
                }
            }
        },
        // 奕森定制化
        getPrint() {
            this.$http
                .get(`/QCCVAS-BIZ-ORDER/stockOutIn/yisen/print/${this.printData.id}`)
                .then((res) => {
                    if (res.data.success) {
                        this.info = res.data.data;
                        this.info.goods.push(
                            { name: `合计 ： ${res.data.data.total}` },
                            {
                                name: `合计（大写）：${this.Nzh.encodeB(res.data.data.total)}`
                            }
                        );
                        this.$forceUpdate();
                    }
                });
        }
    }
};
</script>
<style scoped lang='scss'>
.print-table {
  margin-top: 10px;
}
.print-table /deep/ .cell {
  white-space: pre-wrap !important;
  overflow: initial !important;
  text-align: left !important;
}
.print-table /deep/ .el-table__fixed-header-wrapper,
.print-table /deep/ .el-table__header-wrapper {
  background-color: transparent !important;
  border-top: none !important;
}

.print-table /deep/ .el-table--border {
  border-top: none !important;
}
</style>



// WEBPACK FOOTER //
// src/views/cloud/order/stockOut/PrintOrder.vue